import { LeaderboardUser } from '@sparx/api/apis/sparx/leaderboards/leaderboards/v1/leaderboards';
import { FCWithChildren } from 'utils/props';

interface IAllUsersOptedOutProps {
  users?: LeaderboardUser[];
}

export const AllUsersOptedOut: FCWithChildren<IAllUsersOptedOutProps> = ({ users, children }) =>
  users?.length === 0 ? <>All students are opted out of this leaderboard</> : <>{children}</>;
